import { render, staticRenderFns } from "./RoomEquipmentInfo.vue?vue&type=template&id=10afcf2a&scoped=true&"
import script from "./RoomEquipmentInfo.vue?vue&type=script&lang=js&"
export * from "./RoomEquipmentInfo.vue?vue&type=script&lang=js&"
import style0 from "./RoomEquipmentInfo.vue?vue&type=style&index=0&id=10afcf2a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10afcf2a",
  null
  
)

export default component.exports